import initialState from '../initialstate';
import * as actions from '../../actions/actiontypes';

export default function HelixProjectFilterMetadataReducer(state = initialState.helixProjectFilterMetadata, action) {
	switch (action.type) {
		case actions.GET_PROJECT_FILTERMETADATA_BY_PROJECTID_FROM_HELIX:
			let newState = {...state};
			if (action.error) {
				newState.result = false;
				if (action.error?.response?.data?.error?.code) {
					newState.errorCode = action.error.response.data.error.code;
				}
			} else {
				newState.result = action.response;
				return {
					...newState,
					currencyData: action.response?.analyzers[0]?.filter?.currencyData
				};
			}
			return newState;
		case actions.CLEAR_PROJECT_FILTERMETADATA:
			return initialState.helixProjectFilterMetadata;
		default:
			return state;
	}
}
